import * as React from "react"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";
import { TEXT_BODY, TEXT_HEADING } from "../../styles/homepageSections";

interface Props {
    gatsbyImage?: IGatsbyImageData;
    publicURL?: string;
    title: string;
    description: string;
    variant?: "default" | "tinted";
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
        },
        iconWrap: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: 96,
            marginBottom: 24,
            [theme.breakpoints.up('md')]: {
                height: 100,
                marginBottom: 28,
            },
        },
        img: {
            maxWidth: '90px',
            maxHeight: '90px',
        },
        imgTinted: {
            filter:
                "brightness(0) saturate(100%) invert(35%) sepia(79%) saturate(2476%) hue-rotate(314deg) brightness(95%) contrast(91%)",
        },
        content: {
            width: '100%',
        },
        title: {
            color: TEXT_HEADING,
            fontWeight: 600,
            fontSize: 22,
            lineHeight: 1.35,
            margin: '0 0 12px',
            [theme.breakpoints.up('md')]: {
                fontSize: 28,
                lineHeight: 1.3,
                marginBottom: 16,
            },
        },
        descriptionText: {
            color: TEXT_BODY,
            fontSize: 18,
            lineHeight: 1.55,
            fontWeight: 'normal',
            margin: 0,
            [theme.breakpoints.up('md')]: {
                fontSize: 20,
                lineHeight: 1.6,
            },
        },
    }),
);

const CardBasic: React.FC<Props> = ({ gatsbyImage, publicURL, title, description, variant = "default" }) => {
    const classes = useStyles();
    const tinted = variant === "tinted";

    const imgClass = [classes.img, tinted && classes.imgTinted].filter(Boolean).join(" ");

    return <div className={classes.root}>
        <div className={classes.iconWrap}>
            {publicURL ? <img src={publicURL} alt="" className={imgClass} /> : <GatsbyImage image={gatsbyImage} alt="" className={imgClass} />}
        </div>
        <div className={classes.content}>
            <Typography component="h3" className={classes.title}>
                {title}
            </Typography>
            <Typography component="p" className={classes.descriptionText}>
                {description}
            </Typography>
        </div>
    </div>
}

export default CardBasic
